{
  "en": {
    "baseChip": {
      "states": {
        "included": "included",
        "excluded": "excluded"
      }
    }
  }
}
